/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S61_Item_1Inputs */

const es_tyc_liability_s61_item_1 = /** @type {(inputs: Tyc_Liability_S61_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdida de ganancias, ingresos, oportunidades comerciales o buena voluntad.`)
};

const en_tyc_liability_s61_item_1 = /** @type {(inputs: Tyc_Liability_S61_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loss of profits, revenue, business opportunities, or goodwill.`)
};

/**
* | output |
* | --- |
* | "Loss of profits, revenue, business opportunities, or goodwill." |
*
* @param {Tyc_Liability_S61_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s61_item_1 = /** @type {((inputs?: Tyc_Liability_S61_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S61_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s61_item_1(inputs)
	return en_tyc_liability_s61_item_1(inputs)
});
export { tyc_liability_s61_item_1 as "tyc.liability.s61_item_1" }